<template>
  <div id="creek-audio-toolbar" :style="{'display':'block'}">
    <div class="creek-audio-toolbar-inner">
      <creek-audio-seek-bar></creek-audio-seek-bar>
      <div class="creek-audio-controls">
        <button class="creek-audio-main-button creek-audio-play-button" @click="Creek.audio.toggle(CurrentAudio.API)">
          <span class="creek-audio-button-before-icon" v-if="Creek.config.audio.beforeIcon" v-html="Creek.config.audio.beforeIcon">Listen</span>
          <span class="creek-audio-button-icon fa-stack">
            <i v-if="CurrentAudio.playable===true || CurrentAudio.playable===null" class="creek-audio-play-icon fa fa-play fa-fw fa-stack-1x"></i><i v-if="CurrentAudio.playable===false && CurrentAudio.state!='loading'" class="creek-audio-pause-icon fa fa-pause fa-fw fa-stack-1x"></i><i v-if="CurrentAudio.state=='loading'" class="creek-audio-loading-icon fa fa-circle-o-notch fa-fw fa-stack-1x fa-spin"></i>
          </span>
        </button>
        <creek-audio-toolbar-volume></creek-audio-toolbar-volume>
        <a class="creek-audio-show-image creek-persist-link"><img src="" /></a>
        <div class="creek-live-data" v-if="CurrentAudio.API.Show || CurrentAudio.API.Broadcast">
          <a class="creek-audio-switch-to-live" v-if="CurrentAudio.type=='file'" @click="Creek.audio.live.play()">Back to live</a>
          <div class="creek-show-title-container">
            <a class="creek-show-title creek-show-link creek-audio-title creek-audio-link creek-persist-link" :href="Creek.config.shows.router.basePath + Creek.config.shows.router.pathPrefix + '/' + (CurrentAudio.API.Show.short_name || CurrentAudio.API.Show.attributes.short_name)" v-text="CurrentAudio.API.Show.title || CurrentAudio.API.Show.attributes.title"></a>
          </div>
          <div class="creek-show-time" v-if="CurrentAudio.API.Show.Airtime">
            <span v-text="CurrentAudio.API.Show.Airtime.start_nice" class="start"></span> - 
            <span v-text="CurrentAudio.API.Show.Airtime.end_nice" class="end"></span>
          </div>
          <div class="creek-track" v-if="CurrentAudio.API.Track && CurrentAudio.API.Track !== null"><a :href="CurrentAudio.content.URL" class="creek-persist-link creek-broadcast-link"><div class="creek-track-album-art"></div><span class="creek-track-artist" v-if="CurrentAudio.API.Track.artist" v-text="CurrentAudio.API.Track.artist"></span><span v-if="CurrentAudio.API.Track.title && CurrentAudio.API.Track.artist" class="creek-track-divider"> - </span><span class="creek-track-title" v-if="CurrentAudio.API.Track.artist" v-text="CurrentAudio.API.Track.title"></span></a></div>
          <div class="creek-broadcast" v-if="CurrentAudio.API.Broadcast"><a :href="Creek.config.shows.router.basePath + Creek.config.shows.router.pathPrefix + '/broadcasts/' + CurrentAudio.API.Broadcast.id" v-text="CurrentAudio.API.Broadcast.title || CurrentAudio.API.Broadcast.attributes.title" class="creek-persist-link creek-broadcast-link" ></a> &nbsp; </div>
          <!-- <div class="creek-track-none">&nbsp;</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import AudioToolbarVolume from './AudioToolbarVolume';
import AudioSeekBar from './AudioSeekBar';
export default {
  name: 'creek-audio-toolbar',
  props: ['config'], //TODO: be more specific with props.
  data () {
    return {
      Audio: this.Creek.audio
    }
  },
  components: {
    'creek-audio-toolbar-volume': AudioToolbarVolume,
    'creek-audio-seek-bar': AudioSeekBar
  },
  methods: {
    backToLive(){
      // Switch to, and start playing, current live audio stream.
      this.Creek.audio.live.switch(true);
    }
  },
  computed: {
    CurrentAudio(){
      return this.Creek.audio[this.Creek.audio.type];
    },
    albumArtURL() {
      if(this.CurrentAudio.API.Track && this.CurrentAudio.API.Track !== null){
        "https://art-cdn.creek.fm/api/150/" + encodeURIComponent(this.CurrentAudio.API.Track.artist || '' + " - " + this.CurrentAudio.API.Track.title || '')
      }
      else{
        return null;
      } 
    }
  }
}
</script>

<style lang="stylus" scoped="true">

#creek-audio-toolbar
  
  position fixed
  z-index 999999
  bottom 0
  left 0
  width 100%
  background rgba(255,255,255,1)
  box-shadow 0 0 8px rgba(0,0,0,.2)
  font-size 18px
  line-height 140%
  min-height 64px

  .creek-audio-toolbar-container
    padding 10px 20px
  
  .creek-audio-toolbar-inner
    padding 10px 20px 
    max-width 1100px 
    margin 0 auto 
  
  .creek-audio-toolbar
    float none 
  
  div.creek-audio-info
    float none 
  
  .creek-live-data
    float left
    text-align left

  .creek-track 
    overflow hidden
  
  .creek-audio-show-image
    float left 
    width 0 !important 
    display none !important 
    transition all 1s
    
  .creek-track-album-art
    height 34px
    width 0px
    float left
    margin-right 0px
    background-size cover
    transition all 1s

  .creek-audio-toolbar-container
    padding 10px 20px 

  .creek-audio-main-button
    float left 
    font-size 20px 

    .fa-stack
      line-height 80% 



body.creek-track-has-album-art #creek-audio-toolbar .creek-track-album-art
  width 34px
  margin-right 10px
  display block !important
  transition all 1s

body.creek-audio-has-show-image .creek-audio-show-image
  width auto !important 
  display block !important 
  transition all 1s


#creek-audio-toolbar-spacer {
  
}


</style>
